
import { useTranslation } from "react-i18next";

export default function ContentSection() {
  const { t } = useTranslation();

  const contentItems = [
    t("content_item1"),
    t("content_item2"),
    t("content_item3"),
    t("content_item4"),
    t("content_item5")
  ];

  return (
    <section id="content" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl sm:text-5xl font-bold text-center text-gray-900 mb-8">
          {t("content_title")}
        </h2>
        
        <p className="text-xl text-gray-600 text-center mb-12 text-justify max-w-3xl mx-auto">
          {t("content_subtitle")}
        </p>

        <div className="bg-gradient-to-br from-orange-50 to-pink-50 rounded-2xl p-8 sm:p-12 mb-12">
          <ul className="space-y-4 mb-8">
            {contentItems.map((item, index) => (
              <li key={index} className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-teal-600 text-lg"></i>
                </div>
                <span className="text-lg text-gray-700 leading-relaxed text-justify flex-1">{item}</span>
              </li>
            ))}
          </ul>

          <div className="bg-white rounded-xl p-6 shadow-md">
            <p className="text-lg font-semibold text-teal-600 mb-2">{t("content_goal")}</p>
            <p className="text-gray-700 leading-relaxed text-justify">{t("content_goal_text")}</p>
          </div>
        </div>

        {/* Lesson Plans */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          {/* 25-minute lesson */}
          <div className="bg-gradient-to-br from-teal-50 to-white rounded-2xl p-8 shadow-lg border border-teal-100">
            <h3 className="text-2xl font-bold text-teal-600 mb-6 text-center">
              {t("lesson_25_title")}
            </h3>
            <div className="space-y-4">
              <div className="bg-white rounded-lg p-4 shadow-sm">
                <h4 className="font-bold text-gray-900 mb-2">{t("lesson_25_step1_title")}</h4>
                <p className="text-gray-600 text-sm leading-relaxed text-justify">{t("lesson_25_step1_desc")}</p>
              </div>
              <div className="bg-white rounded-lg p-4 shadow-sm">
                <h4 className="font-bold text-gray-900 mb-2">{t("lesson_25_step2_title")}</h4>
                <p className="text-gray-600 text-sm leading-relaxed text-justify">{t("lesson_25_step2_desc")}</p>
              </div>
              <div className="bg-white rounded-lg p-4 shadow-sm">
                <h4 className="font-bold text-gray-900 mb-2">{t("lesson_25_step3_title")}</h4>
                <p className="text-gray-600 text-sm leading-relaxed text-justify">{t("lesson_25_step3_desc")}</p>
              </div>
              <div className="bg-white rounded-lg p-4 shadow-sm">
                <h4 className="font-bold text-gray-900 mb-2">{t("lesson_25_step4_title")}</h4>
                <p className="text-gray-600 text-sm leading-relaxed text-justify">{t("lesson_25_step4_desc")}</p>
              </div>
            </div>
          </div>

          {/* 50-minute lesson */}
          <div className="bg-gradient-to-br from-orange-50 to-white rounded-2xl p-8 shadow-lg border border-orange-100">
            <h3 className="text-2xl font-bold text-orange-600 mb-6 text-center">
              {t("lesson_50_title")}
            </h3>
            <div className="space-y-4">
              <div className="bg-white rounded-lg p-4 shadow-sm">
                <h4 className="font-bold text-gray-900 mb-2">{t("lesson_50_step1_title")}</h4>
                <p className="text-gray-600 text-sm leading-relaxed text-justify">{t("lesson_50_step1_desc")}</p>
              </div>
              <div className="bg-white rounded-lg p-4 shadow-sm">
                <h4 className="font-bold text-gray-900 mb-2">{t("lesson_50_step2_title")}</h4>
                <p className="text-gray-600 text-sm leading-relaxed text-justify">{t("lesson_50_step2_desc")}</p>
              </div>
              <div className="bg-white rounded-lg p-4 shadow-sm">
                <h4 className="font-bold text-gray-900 mb-2">{t("lesson_50_step3_title")}</h4>
                <p className="text-gray-600 text-sm leading-relaxed text-justify">{t("lesson_50_step3_desc")}</p>
              </div>
              <div className="bg-white rounded-lg p-4 shadow-sm">
                <h4 className="font-bold text-gray-900 mb-2">{t("lesson_50_step4_title")}</h4>
                <p className="text-gray-600 text-sm leading-relaxed text-justify">{t("lesson_50_step4_desc")}</p>
              </div>
              <div className="bg-white rounded-lg p-4 shadow-sm">
                <h4 className="font-bold text-gray-900 mb-2">{t("lesson_50_step5_title")}</h4>
                <p className="text-gray-600 text-sm leading-relaxed text-justify">{t("lesson_50_step5_desc")}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Homework */}
        <div className="bg-gradient-to-br from-pink-50 to-white rounded-2xl p-8 shadow-lg border border-pink-100">
          <h3 className="text-2xl font-bold text-pink-600 mb-6 text-center">
            {t("homework_title")}
          </h3>
          <ul className="space-y-3">
            <li className="flex items-start space-x-3">
              <div className="w-6 h-6 bg-pink-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-pencil-line text-pink-600 text-sm"></i>
              </div>
              <span className="text-gray-700 leading-relaxed text-justify flex-1">{t("homework_item1")}</span>
            </li>
            <li className="flex items-start space-x-3">
              <div className="w-6 h-6 bg-pink-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-mic-line text-pink-600 text-sm"></i>
              </div>
              <span className="text-gray-700 leading-relaxed text-justify flex-1">{t("homework_item2")}</span>
            </li>
            <li className="flex items-start space-x-3">
              <div className="w-6 h-6 bg-pink-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-gamepad-line text-pink-600 text-sm"></i>
              </div>
              <span className="text-gray-700 leading-relaxed text-justify flex-1">{t("homework_item3")}</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
